// Components==============
import React, { createContext, useMemo, useState } from 'react';
import { TranslateType } from 'typings';
// =========================

type GlobalAlertContextType = {
  alert: TranslateType;
  setAlert: React.Dispatch<React.SetStateAction<TranslateType>>;
  customTitle: string | null;
  setCustomTitle: React.Dispatch<React.SetStateAction<string | null>>;
};

export const GlobalAlertContext = createContext({} as GlobalAlertContextType);

export default function GlobalAlert({
  children,
}: {
  children: React.ReactNode;
}) {
  const [alert, setAlert] = useState<TranslateType>('');
  const [customTitle, setCustomTitle] = useState(null);

  const value = useMemo(
    () => ({
      alert,
      setAlert,
      customTitle,
      setCustomTitle,
    }),
    [alert, customTitle]
  );

  return (
    <GlobalAlertContext.Provider value={value}>
      {children}
    </GlobalAlertContext.Provider>
  );
}
